
  import { Component, Vue } from 'vue-property-decorator';
  import { Action, Getter } from 'vuex-class';
  import { Prompt, TemplateParameters } from '../data-access/rephrase'
  import BoxList from '../components/RephraseParameters/BoxList.vue';
  import TwoLinesList from '../components/RephraseParameters/TwoLinesList.vue';
  import ParamToComponent from '../ParamToComponent.json';
  import RephraseTester from '../components/RephraseParameters/RephraseTester.vue';

  @Component({
    name: 'RephraseView',
    components: {
      BoxList,
      TwoLinesList,
      RephraseTester 
    }
  })
  export default class RephraseView extends Vue {
    @Getter('prompts', { namespace: 'rephrase' }) prompts!: Prompt[];
    @Getter('templateParameters', { namespace: 'rephrase' }) templateParameters!: TemplateParameters[];

    @Action('fetchPromptsFromTenant', { namespace: 'rephrase' }) fetchPromptsFromTenant!: any;
    @Action('fetchPromptParametersFromTenant', { namespace: 'rephrase' }) fetchPromptParametersFromTenant!: any;
    @Action('fetchAuthorizedLangsFromTenant', { namespace: 'rephrase' }) fetchAuthorizedLangsFromTenant!: any;
    @Action('fetchTemplateParameters', { namespace: 'rephrase' }) fetchTemplateParameters!: any;
    @Action('createPrompt', { namespace: 'rephrase' }) createPrompt!: any;
    @Action('updatePrompt', { namespace: 'rephrase' }) updatePrompt!: any;
    @Action('deletePrompt', { namespace: 'rephrase' }) deletePrompt!: any;
    @Action('setCurrentPromptId', { namespace: 'rephrase' }) setCurrentPromptId!: any;

    componentData: Record<string, string[]> = ParamToComponent;

    newPrompts : Prompt[] = [];
    promptID : string | null = "";
    name : string = "";
    description : string = "";
    goodTemplateParameters: string[] = [];
    isEditing: boolean = false;
    dialogVisible: boolean = false;
    snackbar: any = {
      color: null,
      icon: null,
      mode: "multi-line",
      text: null,
      timeout: 3000,
      title: null,
      visible: false
    };
    loading: boolean = false;

    async created() {
      this.setPromptData(0);
    }

    async setPromptData(index: number) {
      this.loading = true;
      await this.fetchPromptsFromTenant();
      await this.fetchPromptParametersFromTenant();
      await this.fetchAuthorizedLangsFromTenant();
      await this.fetchTemplateParameters();
      this.loading = false;
      
      this.name = this.prompts[index].name;
      this.name = this.prompts[index].description;
      this.promptID = this.prompts[index].id;
      this.newPrompts = this.prompts;
      this.changePromptID();
    }

    getComponentName(templateId: string): string {
      return Object.keys(this.componentData).find(key => this.componentData[key].includes(templateId)) || '';
    }

    changePrompt() {
      this.newPrompts = this.newPrompts.map(pr => pr.id === this.promptID ? { ...pr, name: this.name, description: this.description } : pr)
    }

    changePromptID() {
      this.setCurrentPromptId(this.promptID);
      this.name = this.prompts.filter(pr => pr.id === this.promptID)[0].name;
      this.description = this.prompts.filter(pr => pr.id === this.promptID)[0].description;
      const goodPrompt = this.prompts.find(pr => pr.id === this.promptID);
      this.goodTemplateParameters = this.templateParameters.filter(parameter => parameter.template_id == goodPrompt?.template_id)[0].value;
      this.isEditing = true;
    }

    showSnackbar(title: string, text: string, color: string, icon: string) {
      this.snackbar.color = color;
      this.snackbar.icon = icon;
      this.snackbar.title = title;
      this.snackbar.text = text;
      this.snackbar.visible = true;
    }

    newPrompt() {
      this.newPrompts.push(new Prompt(null, "rephrase-vigogne-2-13b-chat", "", ""));
      this.promptID = null;
      this.changePromptID();
      this.isEditing = false;
    }

    deleteConfirm() {
      this.dialogVisible = true;
    }

    async create() {
      this.isEditing = true;
      const promptToCreate = this.newPrompts.find(pr => pr.id === this.promptID);
      if (!promptToCreate) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.add') as string, "red darken-3", "mdi-alert-circle");
        return;
      }
      const error = await this.createPrompt(promptToCreate);
      if (error) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.add') as string, "red darken-3", "mdi-alert-circle");
      } else {
        this.setPromptData(this.prompts.length - 1);
        this.showSnackbar(this.$t('app.rephrase.success.title') as string, this.$t('app.rephrase.success.text.add') as string, "green darken-3", "mdi-check-circle");
      }
    }

    async update() {
      const promptToUpdate = this.newPrompts.find(pr => pr.id === this.promptID);
      if (!promptToUpdate) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.update') as string, "red darken-3", "mdi-alert-circle");
        return;
      }
      const error = await this.updatePrompt(promptToUpdate);
      if (error) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.update') as string, "red darken-3", "mdi-alert-circle");
      } else {
        this.setPromptData(this.prompts.length - 1);
        this.showSnackbar(this.$t('app.rephrase.success.title') as string, this.$t('app.rephrase.success.text.update') as string, "green darken-3", "mdi-check-circle");
      }
    }

    async deletion() {
      this.dialogVisible = false;
      const promptToDelete = this.newPrompts.find(pr => pr.id === this.promptID);
      if (!promptToDelete) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.delete') as string, "red darken-3", "mdi-alert-circle");
        return;
      }
      const error = await this.deletePrompt(promptToDelete.id);
      if (error) {
        this.showSnackbar(this.$t('app.rephrase.error.title') as string, this.$t('app.rephrase.error.text.delete') as string, "red darken-3", "mdi-alert-circle");
      } else {
        this.setPromptData(0);
        this.showSnackbar(this.$t('app.rephrase.success.title') as string, this.$t('app.rephrase.success.text.delete') as string, "green darken-3", "mdi-check-circle");
      }
    }

    cancel() {
      this.fetchPromptParametersFromTenant();
      this.isEditing = true;
      if(!this.promptID){
        this.setPromptData(0);
      }
    }
  }
